import { Middleware } from '@reduxjs/toolkit';

import {
  disconnectWaitingRoomSocketConnection,
  initializeWaitingRoomSocketConnection,
  onRegisteredToWaitingRoom,
  onUnRegisteredFromWaitingRoom,
  setWaitingRoomSocketConnection,
} from '../store/V2/WaitingRoomSlice';
import { getWaitingRoomSocket } from './socket';

const waitingRoomSocketMiddleware: Middleware = (store) => {
  let socket;

  const initializeSocket = () => {
    socket.connect();

    socket.on('connect', () => {
      store.dispatch(setWaitingRoomSocketConnection(true));
    });

    socket.on('onRegisteredToWaitingRoom', (data) => {
      store.dispatch(onRegisteredToWaitingRoom(data));
    });

    socket.on('onUnRegisteredFromWaitingRoom', (data) => {
      store.dispatch(onUnRegisteredFromWaitingRoom(data));
    });
  };

  const emitEvent = (event, payload) => {
    if (socket && socket.connected) {
      socket.emit(event, payload);
    } else {
      console.warn(`Socket is not connected. Cannot emit event: ${event}`);
    }
  };

  return (next) => (action) => {
    switch (action.type) {
      case initializeWaitingRoomSocketConnection.type:
        if (!socket) {
          socket = getWaitingRoomSocket(action.payload);
          initializeSocket();
        }

        break;

      case disconnectWaitingRoomSocketConnection.type:
        if (socket) {
          socket.disconnect();
          socket = undefined;
        }

        break;

      case 'waitingRoom/registerToWaitingRoom':
      case 'waitingRoom/unRegisterFromWaitingRoom':
      case 'waitingRoom/getWaitingRoomConnections':
        emitEvent(action.type.replace('waitingRoom/', ''), action.payload);
        break;

      default:
        break;
    }

    return next(action);
  };
};

export default waitingRoomSocketMiddleware;
